module.exports = __webpack_public_path__ + "static/img/db-life-img-05@m.c933f72.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life/db-life-img-05@m.jpg
// module id = j+8J
// module chunks = 0